﻿
import axios from 'axios';
import { AppPublishStatusInfoResult } from './publish-repository';
import { TextValueSelectOptionResult } from './Results/text-value-option-result';

export interface SupportedLanguages {
    supportedLanguagesOptions: TextValueSelectOptionResult[];
    hasSupportedLanguages: boolean;
}

interface SupportedLanguagesResponse {
    supportedLanguagesOptions?: TextValueSelectOptionResult[];
    supportedLanguagesSelectListOptions?: TextValueSelectOptionResult[];
    hasSupportedLanguages?: boolean;
}

export interface NavbarSettings {
    sitesWorkspaceBaseUrl: string;
    appPublishStatusInfoResult?: AppPublishStatusInfoResult;
}

export namespace SitesRepository {

    export async function getSupportedLanguages(): Promise<SupportedLanguages> {
        const url = `/Site/SupportedLanguages`;
        const response = await axios.get<SupportedLanguagesResponse>(url);
        const supportedLanguagesOptions = response.data.supportedLanguagesOptions
            ?? response.data.supportedLanguagesSelectListOptions
            ?? [];

        return {
            supportedLanguagesOptions,
            hasSupportedLanguages: response.data.hasSupportedLanguages ?? supportedLanguagesOptions.length > 0
        };
    }

    export async function getNavbarSettings(appIdentifier: string): Promise<NavbarSettings> {
        const url = `/Site/NavbarSettings?appIdentifier=${appIdentifier}`;
        const response = await axios.get<NavbarSettings>(url);
        return response.data;
    }

}
